import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  style: {},
  class: "header align-items-stretch"
}
const _hoisted_2 = {
  class: "d-flex align-items-center d-lg-none ms-n3 me-1",
  title: "Show aside menu"
}
const _hoisted_3 = {
  class: "btn btn-icon btn-active-light-primary",
  id: "kt_aside_mobile_toggle"
}
const _hoisted_4 = { class: "svg-icon svg-icon-2x mt-1" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "d-flex align-items-center flex-grow-1 flex-lg-grow-0" }, [
  /*#__PURE__*/_createVNode("a", {
    href: "#",
    class: "d-lg-none"
  }, [
    /*#__PURE__*/_createVNode("img", {
      alt: "Logo",
      src: "media/logos/logo-3.svg",
      class: "h-30px"
    })
  ])
], -1)
const _hoisted_6 = { class: "d-flex align-items-stretch justify-content-between flex-lg-grow-1" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-stretch",
  id: "kt_header_menu_nav"
}
const _hoisted_8 = {
  key: 1,
  class: "page-title d-flex align-items-center mb-5 mb-lg-0"
}
const _hoisted_9 = { class: "d-flex align-items-center text-dark my-1 fs-4" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Documentation ")
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "h-20px border-gray-200 border-start mx-4" }, null, -1)
const _hoisted_12 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-6 my-1" }
const _hoisted_13 = { class: "breadcrumb-item text-muted" }
const _hoisted_14 = { class: "d-flex align-items-stretch flex-shrink-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_KTMenu = _resolveComponent("KTMenu")
  const _component_router_link = _resolveComponent("router-link")
  const _component_KTTopbar = _resolveComponent("KTTopbar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: [{
        'container-fluid': _ctx.headerWidthFluid,
        container: !_ctx.headerWidthFluid
      }, "d-flex align-items-stretch justify-content-between"]
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("span", _hoisted_4, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/Text/Menu.svg" })
          ])
        ])
      ]),
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        (!_ctx.isDocPage)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_KTMenu)
            ]))
          : _createCommentVNode("", true),
        (_ctx.isDocPage)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _createVNode("h1", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_router_link, {
                  to: "/documentation/changelog",
                  class: "badge badge-light-danger bg-hover-danger text-hover-white fw-bold fs-9 px-2 ms-2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("v" + _toDisplayString(_ctx.version), 1)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11,
              _createVNode("ul", _hoisted_12, [
                _createVNode("li", _hoisted_13, _toDisplayString(_ctx.title), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_14, [
          _createVNode(_component_KTTopbar)
        ])
      ])
    ], 2)
  ]))
}